import { IMedia } from '../../mediaPreview.types.ts'
import css from './preview.module.css'
import Video from '../Video'
import Image from '../../../Common/Image'
import PdfPreview from './PdfPreview'

interface IProps {
  media: IMedia
  loader?: React.ReactNode
}

const Preview = (props: IProps) => {
  let content: React.ReactNode = null

  if (props.media.dataType.includes('image')) {
    content = <Image src={props.media.url} alt={props.media.fileName} />
  }

  const isPdf = props.media.dataType.includes('pdf')
  if (isPdf) {
    content = <PdfPreview url={props.media.url} />
  }

  if (props.media.dataType.includes('video')) {
    content = <Video {...props.media} />
  }

  return (
    <div data-is-pdf={isPdf} className={css.wrapper}>
      {content}
    </div>
  )
}

export default Preview
